import script from "./AdminInfoCards.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminInfoCards.vue?vue&type=script&setup=true&lang=js"

import "./AdminInfoCards.vue?vue&type=style&index=0&id=06fc128e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fc128e"]])

export default __exports__